import { useService } from 'services'
import { WebViewMessage } from '@types'

export function useWebView() {
  const { webView } = useService()

  function sendMessage<T>(data: WebViewMessage<T>) {
    webView.sendMessage(data)
  }

  const isAppWebView = webView.getIsWebview()

  return { sendMessage, isAppWebView }
}
